import BaseApi from '../base/base'

export interface AiTutorAgent {
  id: number
  name: string
  description: string
  image_url: string | null
  avatar_url: string
  welcomeMessage?: string
  supportsVision?: boolean
}

export interface LlmModel {
  id: string
  name: string
  provider: string
  supportsThinking: boolean
  supportsVision: boolean
  thinkingRequired: boolean
}

export default class AiTutorAgentApi extends BaseApi {
  constructor() {
    super()
    this.path = '/ai_tutor_agents'
  }

  async index(params: { targetableId: string, targetableType: string }): Promise<AiTutorAgent[]> {
    this.path = '/ai_tutor_agents'
    const response = await this.getRequest(params)
    return response.data
  }

  async show(id: number, params: { targetableId: string, targetableType: string }): Promise<AiTutorAgent> {
    this.path = `/ai_tutor_agents/${id}`
    const response = await this.getRequest(params)
    return response.data
  }

  async availableModels(params: { targetableId: string, targetableType: string, agentId?: number }): Promise<LlmModel[]> {
    this.path = '/ai_tutor_agents/available_models'
    const requestParams: any = {
      targetableId: params.targetableId,
      targetableType: params.targetableType
    }
    if (params.agentId) {
      requestParams.agent_id = params.agentId
    }
    const response = await this.getRequest(requestParams)
    return response.data
  }
}
